var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLandingPageComunicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24451 11.1139C9.90451 11.1139 11.9112 9.10721 11.9112 6.44721C11.9112 3.78721 9.90451 1.78054 7.24451 1.78054C4.58451 1.78054 2.57784 3.78721 2.57784 6.44721C2.57784 9.10721 4.58451 11.1139 7.24451 11.1139ZM7.24451 4.11388C8.61884 4.11388 9.57784 5.07288 9.57784 6.44721C9.57784 7.82154 8.61884 8.78054 7.24451 8.78054C5.87017 8.78054 4.91117 7.82154 4.91117 6.44721C4.91117 5.07288 5.87017 4.11388 7.24451 4.11388ZM8.41117 12.2805H6.07784C2.86134 12.2805 0.244507 14.8974 0.244507 18.1139V19.2805H2.57784V18.1139C2.57784 16.1842 4.14817 14.6139 6.07784 14.6139H8.41117C10.3408 14.6139 11.9112 16.1842 11.9112 18.1139V19.2805H14.2445V18.1139C14.2445 14.8974 11.6277 12.2805 8.41117 12.2805ZM19.3358 0.189209L17.6862 1.83888C19.2273 3.38238 20.0778 5.43338 20.0778 7.61388C20.0778 9.79438 19.2273 11.8454 17.6862 13.3889L19.3358 15.0385C21.3192 13.054 22.4112 10.4174 22.4112 7.61388C22.4112 4.81038 21.3192 2.17371 19.3358 0.189209Z",
    fill: "#E04F16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0353 3.48854L14.3857 5.14054C15.0472 5.79971 15.4112 6.67821 15.4112 7.61388C15.4112 8.54954 15.0472 9.42804 14.3857 10.0872L16.0353 11.7392C17.1367 10.6379 17.7445 9.17371 17.7445 7.61388C17.7445 6.05404 17.1367 4.58988 16.0353 3.48854Z",
    fill: "#E04F16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLandingPageComunicate);
export default __webpack_public_path__ + "static/media/icon-landing-page-comunicate.cedf915d59a7a8af244e612cacac1914.svg";
export { ForwardRef as ReactComponent };